export default "__VITE_ASSET__BB7i3XPR__"